import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';

const FilesTable = styled('table')(
  ({ theme }) => ({
    width: '100%',
    backgroundColor: theme.palette.action.hover,
    borderCollapse: 'collapse',
    tbody: {
      background: 'none',
    },
    th: {
      textAlign: 'left',
      fontWeight: 'inherit',
    },
    'tr td:first-of-type': {
      textAlign: 'right',
    },
  }),
  addHighContrastStyles(({ theme }) => ({
    backgroundColor: theme.isDark ? 'black' : undefined,
  })),
);

export default FilesTable;
